import { render } from "./WorkbookHeader.vue?vue&type=template&id=07a3f5f6"
import script from "./WorkbookHeader.vue?vue&type=script&lang=js"
export * from "./WorkbookHeader.vue?vue&type=script&lang=js"

import "./WorkbookHeader.vue?vue&type=style&index=0&id=07a3f5f6&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__